if (!customElements.get("wish-list-notification")) {
    customElements.define(
        "wish-list-notification",
        class WishListNotification extends ModalDialog {
            show() {
                this.resetState();
                this.classList.add("wish-list-notification--show");

                setTimeout(() => {
                    this.hide();
                }, 3000);
            }

            connectedCallback() {
            }

            resetState() {
                document.querySelectorAll("wish-list-notification").forEach((notification) => {
                    notification.classList.remove("wish-list-notification--show");
                });
            }

            hide() {
                this.classList.remove("wish-list-notification--show");
            }
        }
    );
}